module.exports = __webpack_public_path__ + "img/hybrid_schedule.327b4a9d.jpg";